import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PlexEnvironment } from '@app/env';
import { IProjectAssetMapping } from '@app/shared/interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectAssetMappingBulkService {
  private http = inject(HttpClient);
  public environment = inject(PlexEnvironment);

  constructor() {
    this.BASE_URL = `${this.environment.apiUrl}`;
  }

  protected BASE_URL = ''

  //overriding base class
  public saveChanges$(deletedItems: IProjectAssetMapping[], updatedItems: IProjectAssetMapping[],
    excludedPropertiesFromSave: Array<string>, createdItems: IProjectAssetMapping[])
    : Observable<IProjectAssetMapping[]> {

    const toUpdate: IProjectAssetMapping[] = [];

    deletedItems.forEach(item => {
      item.ProjectAssetMappingId *= -1;
      toUpdate.push(item);
    });

    updatedItems.forEach(
      item => {
        excludedPropertiesFromSave.forEach(p => {
          delete item[p];
        });
        toUpdate.push(item);
      });
    toUpdate.push(...createdItems);

    let url = `${this.BASE_URL}ProjectAssetMappingsBatch`;
    return this.http.patch<IProjectAssetMapping[]>(url, toUpdate);
  }
}